<div *transloco="let t" class="py-4">
	@if (showGroupName()) {
		<div class="flex justify-between items-center mb-4">
			<h4 class="title font-medium flex items-center gap-x-2">
				<span>{{ permissionGroup.groupName }}</span>

				@if (isDevRole()) {
					<span>({{ permissionGroup.groupId }})</span>
				}
				@if (isSuperAdmin) {
					<button mat-icon-button (click)="renameGroup()" aria-label="Change group name" [matTooltip]="t('permissionStages.changeGroupName')">
						<mat-icon [svgIcon]="icons.get('edit')"></mat-icon>
					</button>
				}
			</h4>
		</div>
	}

	@if (isLoading()) {
		<div @fadeInUp class="flex flex-row justify-center">
			<mat-spinner color="primary"></mat-spinner>
		</div>
	} @else {
		<div class="overflow-hidden">
			<table mat-table [dataSource]="dataSource" matSort matSortActive="role" matSortDirection="desc" matSortDisableClear>
				<!-- Name Column -->
				<ng-container matColumnDef="name">
					<th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by name">Name</th>
					<td mat-cell *matCellDef="let user">
						<div class="flex flex-row items-center justify-start gap-x-2">
							{{ user.lastName }} {{ user.firstName }}
							@if (keycloakId() === user.id) {
								<mat-icon [svgIcon]="icons.get('person')" [matTooltip]="t('permissionStages.you')"></mat-icon>
							}
						</div>
					</td>
				</ng-container>

				<!-- Email Column -->
				<ng-container matColumnDef="email">
					<th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by email">Email/Username</th>
					<td mat-cell *matCellDef="let user">{{ user.userName }}</td>
				</ng-container>

				<!-- Role Column -->
				<ng-container matColumnDef="role">
					<th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by role">
						{{ t('permissionStages.role') }}
					</th>
					<td mat-cell *matCellDef="let user">{{ t('groupRoleType.' + user.role) }}</td>
				</ng-container>

				<!-- Actions Column -->
				<ng-container matColumnDef="actions">
					<th mat-header-cell *matHeaderCellDef></th>
					<td mat-cell *matCellDef="let user" class="text-right">
						<div class="flex justify-end">
							@if (user.id !== keycloakId()) {
								@if (isAdmin || isSuperAdmin) {
									<mat-menu #userMenu="matMenu">
										@if (isSuperAdmin && user.role !== 'SUPER_ADMIN') {
											<button mat-menu-item (click)="changeUserRole(user, 'SUPER_ADMIN')" aria-label="Change role to Super Admin">
												<span>{{ t('permissionStages.setAsSuperAdmin') }}</span>
											</button>
										}
										@if (user.role !== 'ADMIN') {
											<button mat-menu-item (click)="changeUserRole(user, 'ADMIN')" aria-label="Change role to Admin">
												<span>{{ t('permissionStages.setAsAdmin') }}</span>
											</button>
										}
										@if (user.role !== 'MEMBER') {
											<button mat-menu-item (click)="changeUserRole(user, 'MEMBER')" aria-label="Change role to Member">
												<span>{{ t('permissionStages.setAsMember') }}</span>
											</button>
										}
									</mat-menu>
									@if (user.role !== 'SUPER_ADMIN' || allowSuperAdminDeletion()) {
										<button mat-icon-button [matMenuTriggerFor]="userMenu">
											<mat-icon [svgIcon]="icons.get('edit')"></mat-icon>
										</button>
									}
								}
								@if (isSuperAdmin) {
									@if ((user.role === 'SUPER_ADMIN' && allowSuperAdminDeletion()) || user.role !== 'SUPER_ADMIN') {
										<button
											mat-icon-button
											color="warn"
											(click)="removeUserFromGroup(user)"
											aria-label="Delete user"
											[matTooltip]="t('permissionStages.deleteUser')">
											<mat-icon [svgIcon]="icons.get('delete')"></mat-icon>
										</button>
									}
								} @else if (isAdmin) {
									@if (user.role !== 'SUPER_ADMIN') {
										<button
											mat-icon-button
											color="warn"
											(click)="removeUserFromGroup(user)"
											aria-label="Delete user"
											[matTooltip]="t('permissionStages.deleteUser')">
											<mat-icon [svgIcon]="icons.get('delete')"></mat-icon>
										</button>
									}
								}
							}
						</div>
					</td>
				</ng-container>

				<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
				<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
			</table>
		</div>
	}

	@if (dataSource.data.length === 0) {
		<div class="italic p-6 text-center">{{ t('permissionStages.noUsersInGroup') }}</div>
	}
	@if (isAdmin || isSuperAdmin) {
		<div class="w-full my-2 flex justify-end">
			<button mat-flat-button color="primary" (click)="openInviteUserDialog()" aria-label="Add user" [matTooltip]="t('permissionStages.addUser')">
				<mat-icon [svgIcon]="icons.get('add')"></mat-icon>
				{{ t('permissionStages.addUser') }}
			</button>
		</div>
	}
</div>
